import { commCgi } from '../request';

/**
 * 获取当前服务器端unix时间戳
 * @returns {Promise.<*>}
 */
export async function reqTime(): Promise<number> {
  const res = await commCgi('spp_get_confi', {
    cmd: 1,
    config_id: 1,
  });
  if (!res || !res.result || res.result.code !== 0 || !res.result.now) {
    // throw new Error(res.ret, '获取服务器时间失败', res, RequestErrorType.SYSTEM_ERR);
    const err = new Error(`${res.msg}(${res.ret})`);
    (err as any).code = res.ret;
    (err as any).msg = res.msg;
    (err as any).res = res;
  }
  const time: number = Date.parse(res.result!.now.replace(/-/g, '/'));
  if (Number.isNaN(time)) {
    // throw new Error(res.ret, '获取服务器时间格式出错', res, RequestErrorType.SYSTEM_ERR);
    const err = new Error(`${res.msg}(${res.ret})`);
    (err as any).code = res.ret;
    (err as any).msg = res.msg;
    (err as any).res = res;
  }
  return time;
}

let reqServerTime: number;
let reqLocalTime: number;

/**
 * 可复用的当前时间获取逻辑
 * @returns {Promise.<*>}
 */
export async function now() {
  if (reqServerTime) {
    return reqServerTime + Math.floor(Date.now() / 1000 - reqLocalTime);
  }
  reqServerTime = await reqTime();
  reqLocalTime = Date.now();
  return reqServerTime;
}
